import { render, staticRenderFns } from "./WorkflowStarter.vue?vue&type=template&id=d9c1b8be"
import script from "./WorkflowStarter.vue?vue&type=script&lang=js"
export * from "./WorkflowStarter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports